<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat business model</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>

            </div>
            <settings-form
                :entity="entity"
                ref="businessmodelformref"
            ></settings-form>
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SettingsForm from "./Forms/SettingsForm.vue";
import SubscriberProfileForm from "./Forms/SubscriberProfileForm.vue";
import businessModels from "@/components/views/businessModels/mixins/businessModels"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "BusinessModelNew",
  components: {SettingsForm, SubscriberProfileForm},
  mixins: [detailActions, businessModels],
  created(BusinessModelService) {
    this.entityService = BusinessModelService
  },
  methods: {
    _processDetailErrorMessage(error) {
      return this.processErrorMessage(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/BusinessModelNew.vue